import React from 'react';

const ArrowMenuDrop = () => (
  <svg
    className="menu-drop"
    width={17}
    height={12}
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.375"
      y="0.543945"
      width="15.609"
      height="10.25"
      rx="5.125"
      stroke="white"
      strokeWidth="0.75"
    />
    <path
      d="M11.6733 4.45402L8.23438 7.04674L4.7955 4.45402"
      stroke="white"
      strokeWidth="0.75"
    />
  </svg>
);

export default ArrowMenuDrop;
